import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import { baseResourceActions, baseResources } from "routes/enum";
import { ANALYTICS_QA_ACTIONS } from "../../../enum";
import asset from "assets/images";

const { USER_MANAGEMENT_ROLES } = baseResources;
const { READ } = baseResourceActions;

const AnalyticsQAReportTDropdown = ({ handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value)}
            options={[
                {
                    value: ANALYTICS_QA_ACTIONS.VIEW,
                    label: "View",
                    baseResources: [`${READ}_${USER_MANAGEMENT_ROLES}`],
                },
            ]}
        />
    );
};

export default AnalyticsQAReportTDropdown;
